// Render maps on page load.
window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.google-map').forEach(function (element) {
		if (typeof element !== 'undefined' && element !== null) {
			function initMap() {
				const listingLatLng = {
					lat: parseFloat(element.dataset.lat),
					lng: parseFloat(element.dataset.lng),
				};
				const map = new google.maps.Map(element, {
					zoom: 14,
					center: listingLatLng,
				});
				const marker = new google.maps.Marker({
					position: listingLatLng,
					map,
					icon: {
						scaledSize: new google.maps.Size(60, 60),
						url: '../../wp-content/themes/realome/assets/images/map-pin-icon.svg',
					},
				});
			}
			const renderMap = initMap();
		}
	});
});
